/**
 * Ustanie zatrudnienia (Etap 15) — jeden fakt, z którego wynika wszystko inne.
 *
 * Tryb i podstawa prawna rozwiązania stosunku pracy nie są ozdobą: wchodzą do
 * bloku V formularza ZUS ZWUA, muszą się zgadzać ze świadectwem pracy („dane
 * w polach 03 i 04 nie mogą być sprzeczne z danymi wynikającymi ze świadectwa
 * pracy" — poradnik ZUS ZWUA) i mogą decydować o prawie do świadczeń
 * emerytalnych. Dlatego zapisujemy je raz, kodami z wykazu ZUS.
 */

/**
 * Tryby, które ten produkt zna, z kodami z poradnika ZUS „Ogólne zasady
 * wypełniania i korygowania dokumentów ubezpieczeniowych" (rozdział VII):
 * kod trybu rozwiązania (część XV) i kod podstawy prawnej (część XVI).
 */
export const TERMINATION_MODES = {
  /** Porozumienie stron — art. 30 § 1 pkt 1 k.p. */
  porozumienie: { zusMode: '22R', legalBasis: '402' },
  /** Wypowiedzenie przez pracodawcę — art. 30 § 1 pkt 2 k.p. */
  wypowiedzenie_pracodawcy: { zusMode: '23R', legalBasis: '403' },
  /** Wypowiedzenie przez pracownika — art. 30 § 1 pkt 2 k.p. */
  wypowiedzenie_pracownika: { zusMode: '24R', legalBasis: '403' },
  /** Bez wypowiedzenia z winy pracownika — art. 52 § 1 pkt 1 k.p. */
  dyscyplinarne: { zusMode: '25R', legalBasis: '404' },
  /** Upływ czasu, na który zawarto umowę — art. 30 § 1 pkt 4 k.p. */
  uplyw_czasu: { zusMode: '28R', legalBasis: '407' },
  /** Zgon pracownika — wygaśnięcie stosunku pracy. */
  zgon: { zusMode: '48W', legalBasis: null },
} as const

export type TerminationMode = keyof typeof TERMINATION_MODES

/**
 * Strona inicjująca rozwiązanie (blok V pole 05 formularza ZUS ZWUA):
 * 1 = pracownik (także gdy rozwiązanie idzie porozumieniem stron z jego
 * inicjatywy), 2 = pracodawca (poradnik ZUS ZWUA, blok V).
 */
export const TERMINATION_INITIATORS = { pracownik: '1', pracodawca: '2' } as const
export type TerminationInitiator = keyof typeof TERMINATION_INITIATORS

/** Czy tryb wymaga wskazania strony inicjującej — zgon jej nie ma. */
export function needsInitiator(mode: TerminationMode): boolean {
  return mode !== 'zgon'
}

/** Fakt ustania zatrudnienia w postaci, w jakiej czyta go ekran i dokument. */
export interface EmploymentTerminationView {
  readonly id: string
  /** Ostatni dzień zatrudnienia. Wyrejestrowanie z ZUS idzie z dniem następnym. */
  readonly endDate: string
  readonly mode: TerminationMode
  /** Kod trybu z wykazu ZUS — do bloku V formularza ZUS ZWUA. */
  readonly zusMode: string
  /** Kod podstawy prawnej z wykazu ZUS; `null` przy wygaśnięciu. */
  readonly legalBasis: string | null
  readonly initiator: TerminationInitiator | null
  readonly reason: string | null
  readonly recordedBy: string | null
  readonly recordedAt: string
}
